// extracted by mini-css-extract-plugin
module.exports = {"banner-host":"_1ACGX-tM2hIhP4GQKgtBaY","banner-host--notification":"_2jaAzQr4sElViouugwdeTh"};